import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import i18next from "../../i18n.js";
import { urls, resources, UserContext } from "../../constants.js";
import { logout, loadAvatar } from "../helpers/HelperFunctions.js";

const LoginBtnControl = () => {
    const userContext = useContext(UserContext);
    const [imgUrl, setImgUrl] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        if (userContext?.login) {
            loadAvatar(userContext.login, userContext.avatarId).then(imgUrl => {
                setImgUrl(imgUrl ?? resources.defaulUserImg);
            });
        }
    }, []);

    const handleProfileClick = () => {
        navigate(urls.profilePage);
    };

    const handleLogoutClick = () => {
        logout();
    };

    return (
        <div className="login-btn">
            <Dropdown>
                <Dropdown.Toggle id="login-btn" variant="light">
                    {imgUrl && <img src={imgUrl} />}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                    <Dropdown.Item onClick={handleProfileClick}>
                        {i18next.t("navigation.profileText")}
                    </Dropdown.Item>
                    <Dropdown.Item onClick={handleLogoutClick}>
                        {i18next.t("navigation.logoutText")}
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default LoginBtnControl;
